import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const getMyOwnInvoice = (pageNumber: number, pageSize: number, SearchString, orderBy, filterlist, Type = null) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.CustomerSalesInvoiceApis.CustomerSalesInvoice.browse,
    method: 'get',
    params: {
        PageNumber: pageNumber,
        PageSize: pageSize,
        SearchString: SearchString,
        OrderByString: orderBy,
        FilterString: filterlist,
        //jobStatus: Type,
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});

export const GetHelpText = (path) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.ResourceApis.GetHelpText,
    method: 'get',
    params: {
       path
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});